import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarModule } from 'primeng/avatar';
import { IUser } from '../../models/user/user.model';
import { UserInitialsPipe } from '../../pipes/user-initials.pipe';
import { BadgeModule } from 'primeng/badge';
import { ImageUrlPipe } from '../../pipes/image-url.pipe';
import { ImageSize } from '../../enums/image/image-sizes.enum';
import { IImage } from '../../models/image/image.model';
import { ILocket } from '../../models/locket/locket.model';
import { AvatarSize, BadgeSeverity } from '../../models/_primeng/primeng.model';
import { SelectedOrgService } from '../../services/selected-org.service';

type IUserType = IUser & { lockets?: ILocket[] } | undefined;

@Component({
  selector: 'app-user-avatar',
  standalone: true,
  imports: [CommonModule, AvatarModule, UserInitialsPipe, BadgeModule, ImageUrlPipe],
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss']
})
export class UserAvatarComponent implements OnInit {
  ImageSize = ImageSize;

  _user: IUserType;
  get user() { return this._user };
  @Input() set user(val: IUserType) { this._user = val; this.makeRefresh(); this.initImgUrl(); };
  _locketOrgId: number | undefined;
  get locketOrgId() { return this._locketOrgId };
  @Input() set locketOrgId(val: number | undefined) { this._locketOrgId = val; this.makeRefresh(); this.initImgUrl(); };
  @Input() size: AvatarSize = 'large';
  @Input() badge: boolean = false;
  @Input() badgeValue: string | undefined;
  @Input() badgeSeverity: BadgeSeverity = null;
  @Input() cacheImg: boolean = true;

  imgUrls: IImage | null = null;


  refresh = true;
  imageLoadFailed = false;

  constructor(
    public selectedOrgService: SelectedOrgService
  ) { }

  ngOnInit(): void {
  }

  initImgUrl() {
    let imgUrls;
    if (this.locketOrgId) {
      imgUrls = this.user?.lockets?.find(l => l.organizationId === this.locketOrgId)?.imageUrls;
    }

    if (!imgUrls) {
      imgUrls = this.user?.photoUrls;
    }
    this.imgUrls = imgUrls ?? null;
  }

  makeRefresh() {
    this.refresh = true;
    // this refresh caused the app being too slow, so it is disabled for now - and i dont even remember why it was needed
    // this.refresh = false;
    // setTimeout(() => {
    //  this.refresh = true;
    // });
  }

}
